export const LOCAL_STORAGE = {
  SELECTED_DEVICE_ID: 'selectedDeviceId',
};
